import { render, staticRenderFns } from "./customAnalytics.vue?vue&type=template&id=a01fb4ca&scoped=true&"
import script from "./customAnalytics.vue?vue&type=script&lang=js&"
export * from "./customAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01fb4ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
